<template>
  <button
    class="custom-button"
    :class="[brandClass, type, {'_profileStyle':profileStyle}]"
    @click="onClick($event)"
    :disabled="disabled"
    :data-tracking-regionid="dataTrackingRegionid" :data-tracking-linkid="dataTrackingLinkid"
  >{{label}}</button>
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'OneButton',
  props: {
    brandClass:{
      type: String,
      required: false,
      default: '__b'
    },
    profileStyle:{
      type: Boolean,
      required: false,
      default: false
    },
    dataTrackingRegionid:{
      type: String,
      required: false
    },
    dataTrackingLinkid:{
      type: String,
      required: false
    },
    type:{
      type: String,
      required: false,
      default: 'primary'
    },
    label:{
      type: String,
      required: true,
      default: 'Button'
    },
    disabled:{
      type: Boolean,
      required: false
    }
  },
  methods: {
    onClick($event) {
      // Can add validation here
      $event.stopImmediatePropagation();
      $event.preventDefault();
      this.$emit('click');
    },
  },
})
</script>

<style lang="scss" scoped>
@import './styles/_fonts.scss';
@import './styles/_variables.scss';
.custom-button{
  width: 100%;
  height: 48px;
  &._profileStyle{
    width: 48%;
    height: 52px;
  }
  &._fullWidth {
    width: auto;
    height: 40px;
    padding: 0 20px;
  }
  margin: 0;
  border-radius: 0px;
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  text-transform: initial;
  border: none;
  cursor: pointer;
  &.__alphabet{
    font-family: AlphabetSansPro-Medium;
    font-weight: 500;
    text-align: left;
    padding-left: 15px;
  }
  &.primary{
    background-color: $blue;
    color: white;
    &._profileStyle{
      background-color: $grey4;
      &:hover{
        background-color: $grey5;
      }
    }
    &:hover{
      background-color: $bmwhover;
    }
    &:disabled{
      cursor: inherit;
      background-color: $blue_disabled;
      &._profileStyle{
        background-color: $grey;
      }
      color: white;
    }
    &.__b{
      &:disabled{
        background-color: $barGrey;
        color: $grey5;
        &.__d{
          background-color: #fff;
          color: $black;
        }
      }
    }
    &.__t{
      background-color: $toyotared;
      &:hover{
        background-color: $toyorared2;
      }
      &:disabled{
        background-color: $toyotared;
        opacity: 0.5;
      }
    }
    &.__alphabet{
      background-color: $alphabetwarmcoral;
      color: $alphabetblue;
      &:hover{
        background-color: $alphabetlightcoral;
      }
      &:disabled{
        background-color: $alphabetdisabled;
        color: $alphabetgrey;
      }
    }
    &.__alphera{
      background-color: $alpherablue;
      &:hover{
        background-color: $alpherablueHover;
      }
      &:disabled{
        background-color: $alpherablueDisabled;
      }
    }
    &.__motorrad{
      background-color: black;
      color: white;
      text-transform: uppercase;
      &.__d{
        background-color: $motorradblue;
        color: white;
      }
      &:hover{
        background-color: $motorradblue;
        &.__d{
          background-color: $motorradblue2;
          color: white;
        }
      }
      &:disabled{
        background-color: $grey5;
        &.__d{
            background-color: $motorraddisabledgrey2;
          }
        &:hover{
          background-color: $grey5;
          &.__d{
            background-color: $motorraddisabledgrey2;
          }
        }
      }
    }
    &.__rr {
      background-color: $rrlightblue;
      font-family: RivieraNights-Bold;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: black;
      font-size: 14px;
      &:hover{
        opacity: 0.6;
      }
      &:disabled {
        background-color: $rrdisabled;
        opacity: 0.6;
      }
    }
  }
  &.secondary{
    border: 1px solid black;
    background-color: white;
    &:hover{
      border: 2px solid black;
    }
    &.__m{
      background-color: black;
      color: white;
      &:hover{
        border: 2px solid black;
        background-color: white;
        color: black;
      }
      &._profileStyle{
        background-color: white;
        color: black;
        border: 2px solid black;
        &:hover{
          background-color: white;
          color: black;
          border: 3px solid black;
        }
      }
    }
    &.__t{
      background-color: $dusty;
      border-color: $dusty;
      color: white;
      &:hover{
        background-color: $toyotagrey;
      }
    }
    &.__b{
      &.__d{
        border: 1px solid white;
        background-color: $bmwdarkmodebg;
        color: white;
        &:hover{
          border: 2px solid white;
        }
      }
    }
    &.__alphabet{
      background-color: $alphabetfreshblue;
      border-color: $alphabetfreshblue;
      &._profileStyle{
        background-color: transparent;
        border-color: $alphabetblue;
        color: $alphabetblue;
        &:hover{
          background-color: transparent;
          border-color: $alphabetblue;
          color: $alphabetblue;
        }
      }
      &:hover{
        border: 1px solid;
        background-color: $alphabetfreshbluelight;
        border-color: $alphabetfreshbluelight;
      }
      &:disabled{
        background-color: $alphabetdisabled;
        color: $alphabetgrey;
      }
      &.__d{
        border: 1px solid white;
        background-color: $bmwdarkmodebg;
        color: white;
      }
    }
    &.__alphera{
      border: none;
      color: white;
      background-color: $grey4;
      &:hover{
        background-color: $grey10;
      }
      &:disabled{
        background-color: $grey9;
      }
    }
    &.__motorrad{
      border: 2px solid;
      background-color: white;
      color: black;
      text-transform: uppercase;
      &.__d{
        background-color: $motorradlightblue;
        color: $motorradblue;   
        border: none;     
      }
      &:hover{
        border-color: $motorradblue;
        background-color: $motorradblue;
        color: white;
        &.__d {
          background-color: $motorradblue2;
        }
      }
      &:disabled{
        background-color: $grey5;
        &.__d{
            background-color: $motorraddisabledgrey2;
          }
        &:hover{
          background-color: $grey5;
          &.__d{
            background-color: $motorraddisabledgrey2;
          }
        }
      }
    }
    &.__rr {
      background-color: transparent;
      color: $rrlightblue;
      font-family: RivieraNights-Bold;
      text-transform: uppercase;
      border: none;
      letter-spacing: 2px;
      font-size: 14px;

      &:disabled {
        color: $rrdisabled;
        opacity: 0.6;
      }

      &:hover{
        opacity: 0.6;
      }

    }
  }
  &.tertiary{
    background-color: $grey4;
    color: white;
    &:hover{
     background-color: $grey5;
    }
    &.__t{
      background-color: $toyotared;
      color: white;
      &:hover{
        background-color: $toyorared2;
      }
    }
    &.d__{
      background-color: white;
      color: $bmwdarkmodebg;
    }
    &.__alphabet{
      background-color: $alphabetwarmcoral;
      color: $alphabetblue;
      &:hover{
        background-color: $alphabetlightcoral;
      }
      &:disabled{
        background-color: $alphabetdisabled;
        color: $alphabetgrey;
      }
    }
    &.__alphera{
      border: 1px solid $grey10;
      color: $grey10;
      background-color: white;
      &:hover{
        border: 2px solid $grey10;
        background-color: white;
      }
      &:disabled{
        border: 1px solid $grey11;
        color: $grey11;
        background-color: white;
      }
    }
    &.__motorrad{
      background-color: black;
      color: white;
      text-transform: uppercase;
      &:hover{
        background-color: $motorradblue;
      }
      &:disabled{
        background-color: $grey5;
      }
    }
  }
  &.__m{
    text-transform: uppercase;
    font-family: MINISansSerif;
    font-size: 18px;
    font-weight: 400;
    padding-top: 3px;
    color: white;
    background-color: $miniprimary;

    &._profileStyle{
      background-color: black;
      color: white;
    }
    &:hover{
      background-color: white;
      color: black;
      border: 2px solid $miniprimary;
      &._profileStyle{
        background-color: white;
        border: 3px solid black;
      }
    }
    &:disabled{
      color: $grey5;
      background-color: $mercury;
      border: 2px solid black;
      &:hover{
        color: $grey5;
        background-color: $mercury;
        border: 2px solid black;
      }
      &._profileStyle{
        color: $dusty;
        background-color: $mercury;
        border: 2px solid $mercury;
      }
    }
  }
  &.__t{
    font-family: ToyotaSemibold;
  }
  &.full{
    width: 100%;
  }
  &.__rr{
    border-radius: 30px;
    font-size: 14px;
  }
  &.__motorrad{
    height: 40px;
    font-family: BMWMotorrad;
  }
}
</style>


